import React, { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Box, TextField, Button, Typography, Grid, useTheme } from "@mui/material"
import LoginError from "../../../components/LoginError"
import { F_START_LOGIN } from "../../../constants/routes"
import useMutation from "../../../hooks/useMutation"

const getCustomColorSx = (theme) => ({
  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.start.main,
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: theme.palette.start.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.start.main,
    },
  },
})

const ResetPassword = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get("email")
  const token = searchParams.get("token")

  const theme = useTheme()

  const [showInfo, setShowInfo] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [newPW, setNewPW] = useState("")

  const { mutate: newPasswordMutation, loading } = useMutation("/auth/newpassword")

  useEffect(() => {
    if (!email || !token) {
      navigate(F_START_LOGIN)
    }
  }, [email, token, navigate])

  const handleResetPW = async (event) => {
    event.preventDefault()

    try {
      await newPasswordMutation({ email, password: newPW, token })
      setShowInfo(true)
    } catch (e) {
      console.log(e.message)
      setErrorMsg(e.message)
      setShowInfo(false)
    }
  }

  return (
    <Grid container>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
      <Grid item xs={10} md={4}>
        <Box
          component="form"
          onSubmit={handleResetPW}
          noValidate
          sx={{
            mx: "auto",
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "start.main",
            borderRadius: "12px",
            p: 3,
            width: "100%",
            mt: 3,
          }}>
          <Typography variant="h6" sx={{ color: "black" }}>
            Passwort zurücksetzen
          </Typography>
          <Typography variant="body2">Hier kannst du ein neues Passwort vergeben</Typography>
          <TextField
            margin="normal"
            disabled={loading || showInfo}
            required
            fullWidth
            type="password"
            id="newPW"
            name="sendPW"
            // autoFocus
            onChange={(e) => setNewPW(e.target.value)}
            variant="outlined"
            label="Passwort"
            sx={{ backgroundColor: "white", height: "3.5rem", borderRadius: "0.3rem", ...getCustomColorSx(theme) }}
          />
          <Button
            type="submit"
            fullWidth
            disabled={!newPW.length || loading || showInfo}
            sx={{ mt: 3, color: "white", backgroundColor: "start.main", height: "3.5rem" }}>
            Weiter
          </Button>
          {showInfo && (
            <Typography variant="body1" sx={{ mt: 2 }} onClick={() => navigate(F_START_LOGIN)}>
              Dein Passwort wurde erfolgreich gespeichert. Du kannst dich mit dem neuen Passwort <u>einloggen</u>.
            </Typography>
          )}
          <LoginError msg={errorMsg} visible={!!errorMsg} />
        </Box>
      </Grid>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
    </Grid>
  )
}

export default ResetPassword
